module.exports = __webpack_public_path__ + "static/img/sustainable.caf753c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/investorRelation/sustainable.png
// module id = 9S2W
// module chunks = 2